import * as z from "zod";

export const SchemaProceso = z.object({
	id: z.string().min(1, "El id es obligatorio"),
	nombre: z.string().min(1, "El nombre es obligatorio"),
	referencia: z.string().min(1, "La referencia es obligatoria"),

	descripcion: z.string(),

	tipo: z.literal("proceso"),
	externo: z.enum(["propio", "externo"], {
		error: "El tipo es obligatorio",
	}),
	alcance: z.enum(["cuna_puerta", "puerta_puerta"], {
		error: "El alcance es obligatorio",
	}),
});
export type SchemaProcesoIn = z.input<typeof SchemaProceso>;
export type SchemaProceso = z.output<typeof SchemaProceso>;
